// /src/entries/unauthorized.tsx
import { mount } from "../main";
import { UnauthorizedPage } from "../pages/errors/UnauthorizedPage";

mount(<UnauthorizedPage />);
